import {get as _get} from "lodash";
import store from "@/store";
import {login} from "@/modules/Auth/service/loginMethods/nestLoginMethod";


export default {
    beforeRouteEnter() {
        let continueUrl =  _get(store.state, 'context.continueUrl');
        login(continueUrl);
    }
}

